export default __webpack_public_path__ + "static/media/how-it-works-mobile.a3927245.png";